var Handlebars = require("/home/dmitra/dev/contrail-charts/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row\"> \n  <div component=\"donut-id\" class=\"col-md-11 col-sm-11 col-xs-11\"></div> \n  <div component=\"control-panel-id\" class=\"col-md-1 col-sm-1 col-xs-1\"></div> \n</div> \n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./examples/radial-chart/pie/template.html
// module id = 51
// module chunks = 0